import { useEffect } from 'react';
import { Outlet, useNavigate, useParams, generatePath } from 'react-router-dom';
import { ButtonPrimary, ButtonSize } from '@ui/src';
import { useAppDispatch, useAppSelector } from '@store';
import { getCards, onCardStatusChange } from '../store/slices/cards/cards';
import Card from '../../../components/partial/card/card';
import CardsList from '../../../components/partial/cards/cards-list';
import CardsTransactions from '../../customers/cards-transactions/list';
import { CustomerType } from '../../customers/types';

import ROUTES from '../../../routes';

import cn from '../corporate.module.css';

const CorporateCustomerCards = (): React.JSX.Element => {
  const {
    cards: {
      cards,
      isLoading,
      statusChangeInProgress,
      updatedCard,
      changeStatusSuccess,
    },
    general: { baseInformation },
  } = useAppSelector((state) => state.corporateCustomers.info);

  const dispatch = useAppDispatch();

  const navigate = useNavigate();
  const { customerId } = useParams();

  useEffect(() => {
    if (!cards) {
      dispatch(getCards());
    }
  }, [dispatch, cards]);

  useEffect(() => {
    let title = baseInformation?.name
      ? `${baseInformation?.name}: Cards`
      : 'Cards';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, [baseInformation?.name]);

  let content;

  if (isLoading) {
    content = <Card isLoading={isLoading} />;
  } else if (!isLoading && cards) {
    content = (
      <>
        <ButtonPrimary
          size={ButtonSize.SMALL}
          text="Order a card"
          className={cn.orderCardButton}
          onClick={() =>
            navigate(
              generatePath(ROUTES.CUSTOMERS_CORPORATE_CARDS_ORDER, {
                customerId: customerId as string,
              }),
            )
          }
        />
        <CardsList
          cards={cards}
          onStatusChange={(data) => dispatch(onCardStatusChange(data))}
          updatedCard={updatedCard}
          statusChangeInProgress={statusChangeInProgress}
          customerType={CustomerType.CORPORATE}
          changeStatusInProgress={statusChangeInProgress}
          changeStatusSuccess={changeStatusSuccess}
          customerId={customerId}
        />
        {cards?.length > 0 && (
          <CardsTransactions
            customerType={CustomerType.CORPORATE}
            cards={cards}
          />
        )}
      </>
    );
  }

  return (
    <div>
      {content}
      <Outlet />
    </div>
  );
};

export default CorporateCustomerCards;
